import {
  RECEIVE_LINES,
  RECEIVE_STATION_DETAIL,
  RECEIVE_TRAIN_POSITION,
  RECEIVE_NOTIFICATION,
  CLOSE_STATION_DETAIL,
} from '../actions'

const initialState = {
  lines: [],
  up: null,
  down: null,
  trains: [],
  notifications: [],
  nankai_update_date: null,
  nankai_update_time: null,
  nankai_scheduleTypes: null,
  koya_update_date: null,
  koya_update_time: null,
  koya_scheduleTypes: null,
  has_window: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_NOTIFICATION:
      return {
        ...state,
        notifications: action.payload.hash_notifications,
      }
    case RECEIVE_LINES:
      return {
        ...state,
        lines: action.payload.lines,
      }
    case RECEIVE_TRAIN_POSITION:
      return {
        ...state,
        trains: action.payload.trains,
        nankai_update_date: action.payload.nankai_update_date,
        nankai_update_time: action.payload.nankai_update_time,
        nankai_scheduleTypes: action.payload.nankai_schedule_types,
        koya_update_date: action.payload.nankai_update_date,
        koya_update_time: action.payload.nankai_update_time,
        koya_scheduleTypes: action.payload.koya_schedule_types
      }
    case RECEIVE_STATION_DETAIL:
      return {
        ...state,
        up: action.payload.up,
        down: action.payload.down,
        has_window: action.payload.has_window
      }
    case CLOSE_STATION_DETAIL:
      return {
        ...state,
        up: null,
        down: null
    }
    default:
      return state
  }
}

export default reducer
